import StartProcessByNameRequest from "../../service/request/StartProcessByNameRequest";
import ProcessApi from "../../service/ProcessService";

export default {
  name: "ChooseProcessDialog",
  props: {
    leadPartyId: {
      type: Number,
      default: 0
    }
  },
  mixins: [],
  data: function() {
    return {
      stateValues: {
        showLinkSentDialog: false,
        checked: []
      },
      isLoading: true,
      processList: []
    };
  },
  created() {
    this.show = true;
  },
  mounted() {
    this.retrieveProcessList();
  },
  methods: {
    retrieveProcessList() {
      ProcessApi.getAllByLead(this, this.leadPartyId, response => {
        this.processList = response.onboardingProcesses;
        this.isLoading = false;
      });
    },
    onClickSendLink() {
      this.isLoading = true;
      const startProcessByNameRequest = new StartProcessByNameRequest();
      startProcessByNameRequest.processName = this.processList.find(
        process => process.code === this.stateValues.checked
      ).name;
      startProcessByNameRequest.variables = [
        {
          code: "leadId",
          value: this.leadPartyId
        },
        {
          code: "domainCode",
          value: this.$store.getters["user"].domainId
        }
      ];

      ProcessApi.startProcessByName(
        this,
        startProcessByNameRequest,
        response => {
          this.isLoading = false;
          this.$emit("onProcessIdCreated");
          this.close();
        },
        error => {
          console.log(error);
          this.isLoading = false;
        }
      );
    },
    onClickCancel() {
      this.close();
    },
    close() {
      this.$emit("onCloseChooseProcessDialog");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/ChooseProcessDialog.js